import { selectPrimaryTeamId, type TeamId, toTeamId } from '@terros/common'
import { useProfile } from './get'

export const usePrimaryTeam = (): TeamId | undefined => {
  const { user } = useProfile()
  if (!user) return undefined
  const directTeamIds = user.teams?.directMemberOf.map(toTeamId) ?? []
  return selectPrimaryTeamId({ primaryTeamId: user.primaryTeam?.teamId, directTeamIds })
}
